import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import './ErrorPage.scss';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { reportDWH } from '../../EsimUpgradeBlockSlice';
import { openWhatsAppChatAsync } from '../../EsimUpgradeBlockAsyncThunk';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import { gtag4 } from '../../../../../utilities/analytics/tracking';

const ErrorPage = (props) => {

    useEffect(() => {

        switch (props.errorDescription) {
            case 'ERROR_OPEN_CHAT_ERROR':
                gtag4({ event: 'EsimLine_IndicationWhatsappClosedError', error: props.errorDescription, action: 'IndicationWhatsappClosedError' });
                break;
            case 'NIUD_NOT_FINISH_ERROR':
                gtag4({ event: 'EsimLine_IndicationNiudError', error: props.errorDescription, action: 'IndicationNiudError' });
                break;
            case 'CHECK_USER_ERROR_BUSINESS_USER':
                //gtag4({ event: 'EsimUpgrade_GeneralError', error: props.errorDescription, action: 'GeneralError' });
                break;
            case 'CREATE_ESIM_ORDER_ERROR':
            case 'NO_ORDER_ERROR':
                gtag4({ event: 'EsimUpgrade_GeneralError', error: props.errorDescription, action: 'GeneralError' });
                props.reportDWH({ actionType: 'eSIM Service Purchase', status: 'Error', messageText: 'General Error' });
                break;
            case 'GET_SUBSCRIBERS_ERROR':
                gtag4({ event: 'EsimUpgrade_GeneralError', error: props.errorDescription, action: 'GeneralError' });
                props.reportDWH({ actionType: 'eSIM Subscribers Page', status: 'Error', messageText: 'No Mobile Subscribers Found' });
                break;
            default:
                gtag4({ event: 'EsimUpgrade_GeneralError', error: props.errorDescription, action: 'GeneralError' });
                props.reportDWH({ actionType: 'OTP Page Step2', status: 'Error', messageText: props.errorDescription });
                break;
        }

    }, []);

    let title = '';
    let subTitle = '';
    let icon = '';

    switch (props.errorDescription) {
        case 'ERROR_OPEN_CHAT_ERROR':
            title = 'מוקד ה-WhatsApp שלנו סגור כרגע';
            subTitle = 'ניתן לפנות למוקד השירות בטלפון';
            icon = 'clock-icon';
            break;
        case 'NIUD_NOT_FINISH_ERROR':
            title = `עדיין לא סיימת את תהליך הניוד שלך ל${window.Config.brand_Name_HE}`;
            subTitle = 'לפני שנוכל להפעיל את קו ה-eSIM שלך יש לבצע ניוד. פרטי הניוד נשלחו אליך במייל ובסמס';
            icon = 'info-icon';
            break;
        case 'CHECK_USER_ERROR_BUSINESS_USER':
            title = 'רק רגע...';
            subTitle = 'נראה שיש לנו עסק עם מנוי עסקי';
            icon = 'error-icon';
            break;
        default:
            title = 'מצטערים, משהו השתבש והתהליך לא הושלם';
            // subTitle = 'נציגנו יחזור אליך בהקדם האפשרי כדי לסיים את התהליך';
            icon = 'error-icon';
            break;
    }

    return (
        <div className='esim-upgrade-error-page-wrapper' data-error={props.errorDescription}>
            <div className='esim-upgrade-error-page'>

                <div className={icon}></div>
                <div className='title'>{title}</div>
                {/* <div className='phone'> קו {props.subscriberNo} </div> */}
                <div className='sub-title'>{subTitle}</div>

                <div className='contact-wrapper'>
                    <div className='links-wrapper'>
                        {
                            props.errorDescription != 'ERROR_OPEN_CHAT_ERROR' &&
                            <div className='contact-link whatsapp'> <a href='#' onClick={(e) => handleOpenWhatsApp(e)}> לנציג שירות ב-WhatsApp </a> </div>
                        }
                        <div className='contact-link call-to-service'>
                            {!isMobile ? (
                                <span className='call-to-service-text'>
                                    חייגו <span style={{ direction: 'ltr' }}>&nbsp;{Config.technicalSupportPhone}&nbsp;</span> לנציג שירות
                                </span>
                            ) : (
                                <a href={`tel:${Config.technicalSupportPhone}`}>
                                    חייגו <span style={{ direction: 'ltr' }}>&nbsp;{Config.technicalSupportPhone}&nbsp;</span> לנציג שירות
                                </a>
                            )}
                        </div>
                    </div>
                </div>

                <div className='button-wrapper'>
                    <BtnSubmit
                        isBusiness={false}
                        text='לאזור אישי'
                        onclick={handlePageContinue}
                        formid='esim-block'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                </div>

            </div>
        </div>
    );


    function handleOpenWhatsApp(e) {
        e.preventDefault();

        if (props.isWhatsAppActive) {
            props.openWhatsAppChatAsync();
        }
        else {
            const whatsAppLink = `https://wa.me/${Config.whatsAppSelfCare}?force_isolation=true&text=`;
            let win = window.open(whatsAppLink, '_blank');
            win.focus();
        }
    }

    function handlePageContinue() {
        buildUrlAndOpenSameWindow(Config.lobbyUrl);
    }

};

const mapStateToProps = (state) => {
    return {
        isWhatsAppActive: state.esimUpgradeBlock.isWhatsAppActive,
        errorDescription: state.esimUpgradeBlock.errorDescription,
        subscriberNo: state.esimUpgradeBlock.loginDetails.subscriberNo,
    };
};

const mapDispatchToProps = {
    reportDWH,
    openWhatsAppChatAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
